import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = ({ onWhatsAppOrder, onCallOrder }) => {
  return (
    <section className="py-12 md:py-16 lg:py-20 bg-primary">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6">
            Ready to Order?
          </h2>
          <p className="text-lg md:text-xl text-white/90 mb-8 md:mb-10 max-w-2xl mx-auto">
            Experience authentic South Sudanese flavors delivered fresh to your door. Order now and taste the difference!
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button
              variant="default"
              size="lg"
              iconName="MessageCircle"
              iconPosition="left"
              onClick={onWhatsAppOrder}
              className="bg-accent hover:bg-accent/90 text-white w-full sm:w-auto"
            >
              Order on WhatsApp
            </Button>
            <Button
              variant="outline"
              size="lg"
              iconName="Phone"
              iconPosition="left"
              onClick={onCallOrder}
              className="bg-white hover:bg-white/90 text-primary border-white w-full sm:w-auto"
            >
              Call Us Now
            </Button>
          </div>

          <div className="mt-8 md:mt-10 flex flex-wrap justify-center gap-6 md:gap-8 text-white/80">
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={20} />
              <span className="text-sm md:text-base">30-45 min delivery</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="ShieldCheck" size={20} />
              <span className="text-sm md:text-base">Quality guaranteed</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Star" size={20} className="fill-current" />
              <span className="text-sm md:text-base">4.9/5.0 rating</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;